import jsbridge from "dev-sdk/lib/jsbridge";

const appInfo = jsbridge.checkApp();

/**
 * 判断是否为app
 */
export function isApp() {
  console.log(appInfo && appInfo.isApp, "isapp =====");
  return appInfo && appInfo.isApp;
}

/**
 * 返回平台类别
 */
export function appPlatfrom() {
  if (appInfo && appInfo.isApp) {
    return appInfo.platform;
  } else {
    return "web";
  }
}

/**
 * 调用app的返回事件
 */
export function backPage() {
  console.log(jsbridge.backPage, "jsbridge.backPage");
  jsbridge.backPage();
}

export function formatOsType() {
  let type = 1;
  if (isApp()) {
    switch (appPlatfrom()) {
      case "ios":
        type = 3;
        break;
      case "android":
        type = 2;
        break;
      default:
        break;
    }
  } else if (process.env.SCOPE.indexOf("pc") !== -1) {
    type = 0;
  }
  return type;
}
